<template>
  <RoleFormPage mode="edit" />
</template>

<script>
import RoleFormPage from './role-form-page.vue';

export default {
  name: 'editpermission',
  components: { RoleFormPage },
};
</script>
